import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service';

const ClinicServicesForm = (props) => {
    const {register, handleSubmit, formState: {errors}} = useForm({
        defaultValues: props.clinicSettings
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const onSubmit = (data) => {
        setIsLoading(true);
        // Create the payload with true/false values
        const payload = {};
        for (const key in data) {
            if (key === "clinicId" || key === "id") {
                payload[key] = data[key]; // Keep these values as-is
                continue;
            }

            if (key === "createdAt" || key === "modifiedAt") {
                continue; // Skip these fields
            }

            // Convert to boolean (checkbox values are already true/false)
            payload[key] = Boolean(data[key]);
        }

        clinicService.updateSettings(props.clinicSettings.clinicId, payload)
            .then(res => {
                setIsLoading(false);
                props.updateSettings(res.data);
            })
            .catch(err => {
                setIsLoading(false);
                setIsError(true);
                setErrorMessage(err.response?.data?.message || "Error updating settings");
            });
    };

    const getServiceIcon = (serviceKey) => {
        switch (serviceKey) {
            case "reminder":
            case "reminderEmail":
            case "reminderCall":
            case "reminderSms":
                return <i className="bi bi-bell me-2"></i>;
            case "recall":
                return <i className="bi bi-calendar-check me-2"></i>;
            case "reputation":
                return <i className="bi bi-star me-2"></i>;
            case "survey":
            case "surveyReminder":
                return <i className="bi bi-clipboard-check me-2"></i>;
            case "booking":
                return <i className="bi bi-bookmark-check me-2"></i>;
            case "twoWayText":
                return <i className="bi bi-chat-left-text me-2"></i>;
            case "isAntispamLaw":
                return <i className="bi bi-shield-lock me-2"></i>;
            case "newsletterEmail":
            case "newsletterSms":
                return <i className="bi bi-envelope me-2"></i>;
            case "blastEmail":
            case "blastSms":
            case "blastCall":
                return <i className="bi bi-megaphone me-2"></i>;
            default:
                return <i className="bi bi-gear me-2"></i>;
        }
    };

    const getServiceLabel = (serviceKey) => {
        const labels = {
            reminder: "Appointment Reminders",
            recall: "Patient Recalls",
            reputation: "Reputation Management",
            survey: "Patient Surveys",
            surveyReminder: "Survey Reminders",
            booking: "Online Booking",
            twoWayText: "Two-way Text Messaging",
            isAntispamLaw: "Anti-Spam Compliance",
            reminderEmail: "Email Reminders",
            reminderCall: "Phone Reminders",
            reminderSms: "SMS Reminders",
            newsletterEmail: "Email Newsletter",
            newsletterSms: "SMS Newsletter",
            blastEmail: "Email Blasts",
            blastSms: "SMS Blasts",
            blastCall: "Call Campaigns"
        };
        return labels[serviceKey] || serviceKey;
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="list-group mb-4">
                {Object.entries(props.clinicSettings).map(([key, value]) => {
                    if (['clinicId', 'id', 'createdAt', 'modifiedAt'].includes(key)) return null;

                    return (
                        <div key={key} className="list-group-item d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                {getServiceIcon(key)}
                                <span>{getServiceLabel(key)}</span>
                            </div>
                            <div className="form-check form-switch">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={key}
                                    {...register(key)}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="d-flex justify-content-between align-items-center">
                <div>
                    {isError && (
                        <div className="alert alert-danger mb-0">
                            <i className="bi bi-exclamation-triangle-fill me-2"></i>
                            {errorMessage}
                        </div>
                    )}
                </div>
                <button
                    type="submit"
                    className="btn btn-success btn-sm"
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Saving...
                        </>
                    ) : (
                        <>
                            <i className="bi bi-floppy"></i> Save
                        </>
                    )}
                </button>
            </div>
        </form>
    );
};

export default ClinicServicesForm;